import OverviewPage, { handle } from '@modules/professional/page/OverviewPage';
import { loader } from '@modules/professional/page/loaders/overview-page-loader.server';

export { loader, handle };
export default OverviewPage;
